module.exports = __webpack_public_path__ + "img/title.b4493223.png";